import { Alert, Box, CircularProgress, Grid, useTheme } from "@mui/material";
import { KpiCard } from "../../programmeDashboard/components/KpiCard";
import { useCommitmentsStates } from "../hooks/useCommitmentsStates";
import { formatCurrency } from "../../../shared/utils";

export const CommitmentsStates = () => {

    const theme = useTheme();
    const { data, isLoading, isError, error } = useCommitmentsStates();

    const kpiData = [
        {
            label: 'Total Commitments',
            value: formatCurrency(data?.total_commitments || 0),
            subValue: '97.0% of budget',
        },
        {
            label: 'Uncommitted Headroom',
            value: formatCurrency(data?.uncommitted_headroom || 0),
            subValue: '3.0% available',
        },
        {
            label: 'Total Accruals',
            value: formatCurrency(data?.total_accruals || 0),
            subValue: '2.4% of budget',
        },
        {
            label: 'Remaining Exposure',
            value: formatCurrency(data?.remaining_exposure || 0),
            subValue: 'Budget minus commitments',
        },
    ];

    if (isLoading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
                my={5}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
            >
                <Alert
                    severity="warning"
                    sx={{
                        width: "auto",
                        justifyContent: "center",
                        textAlign: "center",
                    }}
                >
                    {error?.message || "Something went wrong!"}
                </Alert>
            </Box>
        );
    };

    return (
        <Grid container spacing={2} sx={{ mb: 3 }} px={2}>
            {kpiData.map((item: { label: string; value: string; subValue: string; icon?: React.ReactNode }) => (
                <Grid size={{ xs: 12, sm: 6, md: 3 }} key={item.label}>
                    <KpiCard
                        label={item.label}
                        value={item.value}
                        icon={item.icon}
                        iconColor={theme.palette.info.main}
                        subValue={item.subValue}
                    />
                </Grid>
            ))}
        </Grid>
    );

};